import { h } from '../../utils/html'
import Form from '../../utils/Form'
import { confirmOk } from '@utils/confirm.js'
import http from '../../utils/http'
import { translate } from '../locale/locale.js'
import { useCityStore } from '../../../../store/city.js'
import { popup } from '../popup/popup.js'

const newsletterButton = document.querySelectorAll('[href*="#newsletter-popup"]')
const cityStore = useCityStore()

/**
 * @usage
 * <a href="?listId=2#newsletter-popup">Open newsletter popup</a>
 */
newsletterButton.forEach((el) => {
    el.addEventListener('click', async (e) => {
        e.preventDefault()

        const url = new URL(el.href)
        const params = new URLSearchParams(url.search)
        const listId = params.get('listId')

        const response = await http.get('/newsletter/?city=' + cityStore.currentCity.code)
        const { name, description } = response.data

        await newsletterSignupPopup({ id: listId, name, description })
    })
})

export function newsletterSignupPopup({ id: listId, title, description }) {
    return new Promise((resolve, reject) => {
        const html = h(`
			<div class="popup-split">
				<div class="popup-split__left">
					<img src="/media/img/photos-sale-page/reference-4.jpg" srcset="/media/img/photos-sale-page/reference-4@2x.jpg 2x" alt="">
				</div>
				<div class="popup-split__right d-flex flex-column jc-center text-center text-blue-dark">
					<div class="mx-auto" style="max-width: 400px;">
						<h2 class="popup-split__title">${title || translate('popup_newsletter_title')}</h2>

						<p class="text-md weight-600 leading-normal mt-2">
							${description}
						</p>

						<form action="/newsletter/subscribe/" method="POST" class="pretty-form mx-auto mt-6" style="max-width: 330px;">
							<input type="hidden" name="listId" value="${listId}">

							<div class="form-group">
								<input class="full-width" placeholder="Email" type="email" autocapitalize="off" autocorrect="off" name="email" required>
							</div>

							<div class="form-group">
								<button type="submit" class="flat-button flat-button--blue flat-button--full">
									${translate('popup_newsletter_button')}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		`)

        Form.find(html.querySelector('form'))
            .init()
            .then(() => {
                resolve(true)
                confirmOk(
                    translate('popup_newsletter_thank_you_title'),
                    translate('popup_newsletter_thank_you_message'),
                )
            })
            .catch((error) => reject(error))

        popup({
            content: html,
            width: '1000px',
            height: '550px',
            queue: true,
            beforeClose() {
                resolve(false)
            },
        })
    })
}
